import { render } from "./OlapFilterPanel.vue?vue&type=template&id=3883b1e4&scoped=true&ts=true"
import script from "./OlapFilterPanel.vue?vue&type=script&lang=ts"
export * from "./OlapFilterPanel.vue?vue&type=script&lang=ts"

import "./OlapFilterPanel.vue?vue&type=style&index=0&id=3883b1e4&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3883b1e4"]])

export default __exports__